import { apiGet, apiPost, unwrap } from './apiClient';
import { ResponseDTO, ApplicationDTO, PkgUploadResult, PaginationParams } from '@/types/api';

const BASE = '/api/v1/application/private';

export async function uploadPrivateApp(file: File): Promise<PkgUploadResult> {
  const formData = new FormData();
  formData.append('applicationFile', file);
  const res = await apiPost<ResponseDTO<PkgUploadResult>>(`${BASE}/upload`, formData);
  return unwrap(res);
}

export async function downloadPrivateApp(tenantId: string, appId: string): Promise<Response> {
  return apiGet<Response>(`${BASE}/download`, {
    params: { tenantId, appId },
    rawResponse: true,
  });
}

export async function getManifest(tenantId: string, appId: string): Promise<string> {
  const res = await apiGet<Response>(`${BASE}/manifest`, {
    params: { tenantId, appId },
    rawResponse: true,
  });
  return res.text();
}

export async function downloadIcon(tenantId: string, appId: string): Promise<Blob> {
  const res = await apiGet<Response>(`${BASE}/icon/download`, {
    params: { tenantId, appId },
    rawResponse: true,
  });
  return res.blob();
}

export async function listPrivateApps(pagination?: PaginationParams): Promise<ResponseDTO<ApplicationDTO[]>> {
  return apiGet<ResponseDTO<ApplicationDTO[]>>(`${BASE}/list`, {
    params: pagination as Record<string, string | number | boolean | undefined>,
    includeTenantHeader: true,
  });
}

export async function getPrivateApp(appId: string): Promise<ApplicationDTO> {
  const res = await apiGet<ResponseDTO<ApplicationDTO>>(BASE, {
    params: { appId },
    includeTenantHeader: true,
  });
  return unwrap(res);
}

export async function deletePrivateApp(appId: string): Promise<void> {
  await apiPost<ResponseDTO<unknown>>(`${BASE}/delete`, undefined, {
    params: { appId },
    includeTenantHeader: true,
  });
}
